import loadable, { DefaultComponent, OptionsWithResolver } from '@loadable/component';
import { OverlaySpinner } from 'common/Spinner';

const lazy = (
  imp: () => Promise<DefaultComponent<unknown>>,
  options?: OptionsWithResolver<unknown, DefaultComponent<unknown>>,
) => loadable(imp, { fallback: <OverlaySpinner />, ...options });

export default lazy as typeof loadable;
